export const GET_DATA = '@dashboard/GET_DATA'
export const GET_DATA_FAILURE = '@dashboard/GET_DATA_FAILURE'
export const GET_DATA_SUCCESS = '@dashboard/GET_DATA_SUCCESS'
